import { translateCategory } from "translation/translationService";

// const apiUrl = "http://localhost:5001/api/";
const apiUrl =
  process.env.REACT_APP_API_URL ?? "https://api.comeforhealth.ca/api/";
// const apiUrl = "http://comeforhealth-env-1.eba-3dr2p3s5.us-east-2.elasticbeanstalk.com./api/"; // cant use cause no https
const cookieKey = "authorization";
export const isAdminKey = "isAdmin";

// Retrieve the token

export async function getAllTabbedProducts() {
  let response = await fetch(`${apiUrl}allproducts-tabs-format`, {
    mode: "cors",
  });
  if (response.ok) {
    return response.json();
  }
  return {};
}

export function translateTabs(rawTabs, language) {
  const tabs = structuredClone(rawTabs);
  for (const tabbedProductKey in tabs) {
    // console.log(tabs[tabbedProductKey]?.["products"])
    tabs[tabbedProductKey]?.["products"]?.forEach(
      (tabbedProducts, pageIndex) => {
        // hacky cause lazy for now, supporting on chinese or english
        tabbedProducts.forEach((tabbedProduct, innerIndex) => {
          if (language === "cn") {
            tabs[tabbedProductKey]["products"][pageIndex][innerIndex].title =
              tabbedProduct.translated_title;
            tabs[tabbedProductKey]["products"][pageIndex][innerIndex].category =
              translateCategory(tabbedProduct.category, language);
          }
        });
      }
    );
  }
  return tabs;
}
// export async function getAllProductsHandleFormat() {
//   let response = await fetch(`${apiUrl}allproducts-handle-format`, {
//     mode: "cors",
//   });
//   if (response.ok) {
//     return response.json();
//   }
//   return {};
// }

export async function getProductByHandle(handle) {
  let response = await fetch(`${apiUrl}product/handle-format/${handle}`, {
    mode: "cors",
  });
  if (response.ok) {
    return response.json();
  }
  return {};
}

export async function getProductByHandleWithTranslations(handle) {
  let response = await fetch(`${apiUrl}product/handle-format/all/${handle}`, {
    mode: "cors",
  });
  if (response.ok) {
    return response.json();
  }
  return {};
}

export async function updateProduct(product) {
  const accessToken = getCookieAt(isAdminKey);
  const response = await fetch(`${apiUrl}product`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    credentials: "include",
    body: JSON.stringify(product),
  });
  returnAuthenticatedResponseOrRedirect(response);
  return {};
}

export async function addProduct(product) {
  const accessToken = getCookieAt(isAdminKey);
  const response = await fetch(`${apiUrl}product/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    credentials: "include",
    body: JSON.stringify(product),
  });

  returnAuthenticatedResponseOrRedirect(response);

  return {};
}

export async function deleteProductByObject(product) {
  const accessToken = getCookieAt(isAdminKey);
  const response = await fetch(`${apiUrl}product/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    credentials: "include",
    body: JSON.stringify(product),
  });

  returnAuthenticatedResponseOrRedirect(response);
  return {};
}

export async function sendLogin(username, password) {
  const response = await fetch(`${apiUrl}admin-login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ username: username, password: password }),
  });
  if (response.status !== 200) {
    return {
      error: "Invalid username or password",
    };
  }
  const data = await response.json();
  const accessToken = data["access_token"];
  setAdminCookie(accessToken);

  return {
    message: "Success",
  };
}

export function setAdminCookie(value) {
  addCookie(isAdminKey, value, 1);
}

function addCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + 400 * 60 * 60 * 1000); // 2 hours
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function generateCookieObject() {
  return document.cookie.split("; ").reduce((prev, current) => {
    const [name, ...value] = current.split("=");
    prev[name] = value.join("=");
    return prev;
  }, {});
}

function clearAdminCookie() {
  document.cookie = `${isAdminKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function getCookieAt(key) {
  return generateCookieObject()[key];
}

// // Image Service?

// import { AWS } from "aws-sdk";
// // Load the AWS SDK for Node.js
// // Set the region
// AWS.config.update({ region: "REGION" });

// // Create S3 service object
// s3 = new AWS.S3({ apiVersion: "2006-03-01" });

// // Create the parameters for calling createBucket
// var bucketParams = {
//   Bucket: process.argv[2],
// };

// // call S3 to create the bucket
// s3.createBucket(bucketParams, function (err, data) {
//   if (err) {
//     console.log("Error", err);
//   } else {
//     console.log("Success", data.Location);
//   }
// });

function returnAuthenticatedResponseOrRedirect(response) {
  if (response.ok) {
    return response.json();
  } else if (response.status === 403) {
    clearAdminCookie();
    window.location.href = "/admin/login/?expired=True";
  }
}
